<template lang="jade" src="./target.jade"></template>

<script>
  export default {
    data () {
      return {
        animated_headline: "https://s3-us-west-1.amazonaws.com/db13/1440/hdr.svg",
        title: 'I am your Content',
        copy: 'I am hilarious, quiet, even outrageous innovation. Born of freedom. I strive always to be more than simply entertaining. You will not always love my story. But you will demand your place at the screen to see and choose for yourself, without exception. When I feel something deeply, you will too. You have appeared as if by magic to reimagine me. I fight for you, my loyal seers. Let no corporation put asunder. HDR. Highly Demanding Realities? High Dynamic Range! Because tomorrow is all about the…',
        lastword: 'DREAM',
        video: 'https://s3-us-west-1.amazonaws.com/db13/1440/content-creators.mp4',
        back_link: '/consumers',
        forward_link: '/content-owners',
        back_img: 'imgs/icons/back-arrow.svg',
        forward_img: 'imgs/icons/forward-arrow.svg',
        back: 'imgs/icons/back-arrow.svg',
        vTransparency: {
          opacity: '0.35'
        }
      }
    }
  }
</script>

<style lang="sass?indentedSyntax" scoped>

  @import "../../_sass/utilities/_utilities.sass"

  h1,
  span.beleive
    color: $lt-purple!important

</style>


/** WEBPACK FOOTER **
 ** content-creators.vue?40fd20ce
 **/